import TraneCommercialTermsAndConditions from 'pages/TermsAndConditions/TraneCommercialTermsAndConditions'
import AmericanStandardTermsAndConditions from 'pages/TermsAndConditions/AmericanStandardTermsAndConditions'
import TraneHomeTermsAndConditions from 'pages/TermsAndConditions/TraneHomeTermsAndConditions'

import Brand from 'helpers/brand'

function TermsAndConditionsForm () {
  let Template
  if (Brand.isTraneHome()) {
    Template = TraneHomeTermsAndConditions
  } else if (Brand.isASAirHome()) {
    Template = AmericanStandardTermsAndConditions
  } else {
    Template = TraneCommercialTermsAndConditions
  }
  return (
    <Template />
  )
}

export default TermsAndConditionsForm
